import { FC, Dispatch, SetStateAction } from 'react';
import { Dialog } from 'ui/components/Dialog';
import { DialogType } from './utils';

export interface IFormDialogProps {
	show: boolean;
	/** @deprecated El color de cabecera ya no se usa: el design system fija el estilo. */
	type?: DialogType;
	title?: string;
	content: React.ReactNode;
	actions: React.ReactNode;
	buttonPosition?: 'start' | 'center' | 'end';
	handleClose: Dispatch<SetStateAction<boolean>>;
	maxWidth?: 'sm' | 'md' | 'lg';
	/** @deprecated El design system no tiene pantalla completa. */
	enableFullscreen?: boolean;
}

const justify = { start: 'justify-start', center: 'justify-center', end: 'justify-end' } as const;

export const FormDialog: FC<IFormDialogProps> = ({
	show = false,
	title = 'Título no definido',
	content,
	actions,
	buttonPosition = 'center',
	handleClose,
	maxWidth
}) => {
	return (
		<Dialog
			open={show}
			size={maxWidth ?? 'md'}
			title={title}
			onClose={() => handleClose(false)}
			data-testid="form-dialog">
			{content}
			<div className={`mt-4 flex gap-3 ${justify[buttonPosition]}`}>{actions}</div>
		</Dialog>
	);
};
